@let progress = (progress$ | async) || 0;
@if (collapsed) {
  <card>
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <ng-container *ngTemplateOutlet="fullnameTemplate" />
      </div>

      <button-icon-v2 (click)="collapsed = false" key="plus" color="var(--color-jazlyn-750)" />
    </div>

    <div class="d-flex align-items-center">
      <ng-container *ngTemplateOutlet="phoneTemplate" />
    </div>

    <div class="v2-mt-4">
      <lead-boost-indicator [progress]="progress" [duration]="duration" [mini]="true" />
    </div>
  </card>
} @else {
  <card>
    <div class="d-flex align-items-center justify-content-between">
      <typography-v2 look="subtitle-bold">Request details</typography-v2>

      <button-icon-v2 (click)="collapsed = true" key="minus" color="var(--color-jazlyn-750)" />
    </div>

    <div class="d-flex align-items-center v2-mt-4">
      <ng-container *ngTemplateOutlet="fullnameTemplate" />
    </div>

    <div class="d-flex align-items-center v2-mt-2">
      <ng-container *ngTemplateOutlet="phoneTemplate" />
    </div>

    <div *ngIf="nextLeadAssignment.lead?.hasVoicemail" class="d-flex align-items-center v2-mt-2">
      <rdr-svg-icon key="voicemail" color="var(--color-jazlyn-700)" size="xl" />

      <typography-v2 look="subtitle" class="v2-ml-1" dataId="has-voicemail">
        Voicemail was sent
      </typography-v2>
    </div>
  </card>

  <lead-boost-indicator [progress]="progress" [duration]="duration" />

  @if (progress === duration) {
    <ng-container
      *ngIf="nextLeadAssignment.agentStatus?.awayUntil | minutesRemaining as minutesRemaining"
    >
      <lead-boost-pause *ngIf="minutesRemaining" [minutesRemaining]="minutesRemaining" />
    </ng-container>
  } @else {
    <card class="v2-px-0">
      <button-v2
        (click)="submit(LeadTempAssignmentStatusTypeInput.Busy)"
        [disabled]="loading"
        look="full-width"
        type="secondary"
        data-id="busy-now"
        class="v2-px-4"
      >
        I’m busy now
      </button-v2>

      <hr class="v2-my-4" />

      <button-v2
        (click)="submit(LeadTempAssignmentStatusTypeInput.Completed)"
        [disabled]="loading"
        look="full-width"
        type="call"
        data-id="complete-lead"
        class="v2-px-4"
      >
        Client answered
      </button-v2>

      <button-v2
        (click)="submit(LeadTempAssignmentStatusTypeInput.Voicemail)"
        [disabled]="loading"
        look="full-width"
        type="filter"
        class="v2-mt-4 v2-px-4"
        data-id="voicemail"
      >
        Left a voicemail
      </button-v2>

      <button-v2
        (click)="submit(LeadTempAssignmentStatusTypeInput.NoAnswer)"
        [disabled]="loading"
        look="full-width"
        type="filter"
        class="v2-mt-4 v2-px-4"
        data-id="no-answer"
      >
        Client did not answer
      </button-v2>

      <button-v2
        (click)="submit(LeadTempAssignmentStatusTypeInput.BadNumber)"
        [disabled]="loading"
        look="full-width"
        type="filter"
        class="v2-mt-4 v2-px-4"
        data-id="bad-number"
      >
        Bad number
      </button-v2>
    </card>
  }
}

<ng-template #phoneTemplate>
  <rdr-svg-icon key="phone" color="var(--color-jazlyn-700)" size="xl" />

  <copy-to-clipboard-v2 value="{{ nextLeadAssignment.lead?.phone }}">
    <typography-v2 look="subtitle" class="v2-ml-1 w-100" dataId="lead-phone">
      <a href="tel:{{ nextLeadAssignment.lead?.phone }}">{{ nextLeadAssignment.lead?.phone }}</a>
    </typography-v2>
  </copy-to-clipboard-v2>
</ng-template>

<ng-template #fullnameTemplate>
  <rdr-svg-icon key="profile-full" color="var(--color-jazlyn-700)" size="xl" />

  <typography-v2 look="subtitle" class="v2-ml-1" dataId="lead-name">
    {{ nextLeadAssignment.lead?.fullName }}
  </typography-v2>
</ng-template>
